module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-hours"
  }, [(_vm.isShowOptions) ? _c('label', {
    staticClass: "d-label marg-1-top"
  }, [_vm._v(_vm._s(_vm.i18n['period_hours']))]) : _vm._e(), _vm._v(" "), (_vm.isShowOptions) ? _c('DoDatePickerRange', {
    attrs: {
      "date": _vm.date,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "datesChanged": _vm.setDates
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "is-small": true,
      "bg-color": "#ffffff"
    }
  }) : [_c('div', {
    ref: "dropdown",
    staticClass: "do-card--overflow",
    style: ({
      'maxHeight': _vm.maxHeight
    })
  }, [(_vm.hoursGrouped.length < 1) ? _c('h3', {
    staticClass: "text-explainer marg-1-top"
  }, [_vm._v(_vm._s(_vm.i18n['no_schedule']))]) : _vm._l((_vm.hoursGroupedSorted), function(parentCat) {
    return _c('ul', {
      staticClass: "do-card"
    }, [_c('li', [_c('div', {
      staticClass: "do-hours__item do-hours__item__headline",
      class: {
        'do-hours__item__headline--no-border': parentCat.subCategories.length > 1
      }
    }, [_c('p', [_vm._v(_vm._s(parentCat.vTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(parentCat.vHours))])]), _vm._v(" "), _c('ul', _vm._l((parentCat.subCategories), function(subCat) {
      return _c('li', [(parentCat.subCategories.length > 1) ? _c('div', {
        staticClass: "do-hours__item do-hours__item__sub__headline do-hours__item__child"
      }, [_c('p', [_vm._v(_vm._s(subCat.vTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(subCat.vHours))])]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((subCat.subjects), function(subject) {
        return _c('li', {
          staticClass: "do-hours__item do-hours__item__child"
        }, [_c('p', [_vm._v(_vm._s(subject.vTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(subject.vHours))])])
      }), 0)])
    }), 0)])])
  })], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f73d31cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalculateHours.vue
// module id = 1781
// module chunks = 1